import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const FadingMessage = ({ message, delay }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: visible ? 1 : 0 }}
      transition={{ duration: 1 }} // Adjust the duration as needed
      style={{ display: visible ? "block" : "none" }} // Hide after fade-out
      className="mb-8 label-m-medium text-fg-neutral-strong px-4 py-3 bg-container-brand-minimal rounded-[8px] my-[16px] border border-indigo-200"
      role="status"
      aria-live="polite"
    >
      {message}
    </motion.div>
  );
};

export default FadingMessage;
